<template>
<div class="panel bgPanel mt1x pb1x h21x">
	<div class="title title-bg">
		<span :title="$t('word1578',['实时流动图'])">{{$t("word1578",["实时流动图"])}}</span>
	</div>
	<loading v-show="isLoading"></loading>
	<div class="pl5x pr5x">
		<div class="clearfix pl05x pr05x mb05x">
			<div class="fL tC dpIB_E">
				<svg class="w3x h3x pr05x"><use xlink:href="#ico-getPower"></use></svg>
				<div class="lh15">
					<span :title="getLanguageStr('word559','发电')">{{getLanguageStr('word559','发电')}}</span><br>
					<span class="cMain" :title="convertData(stationInfo.generationPower,2,'','W')[0]"><span class="fs14x">{{convertData(stationInfo.generationPower,2,"","W")[1]}}</span> {{convertData(stationInfo.generationPower,2,"","W")[2]}}</span>
				</div>
			</div>
			<div class="fR">
				<svg class="w3x h3x"> <use xlink:href="#ico-eTower"></use> </svg>
				<div class="dpIB lh15" >
					<span :title="getLanguageStr('word560','电网')">{{getLanguageStr('word560','电网')}}</span><br>
					<span v-if="stationInfo.wirePower==null">--</span>
					<span v-else class="cMain" :title="convertData(Math.abs(stationInfo.wirePower),2,'','W')[0]"><span class="fs14x">{{convertData(Math.abs(stationInfo.wirePower),2,"","W")[1]}}</span> {{convertData(Math.abs(stationInfo.wirePower),2,"","W")[2]}}</span>
				</div>
			</div>
		</div>
		<div class="taC dpIB_E ml2x_E mr2x_E" ref="DashLines">
			<DashLine class="LDash mb05x" :dashLine="true" :viewWidth="DashWidth" :viewHeight="38" :isAnimation="false" :isArrow="false" :isColor="false"  v-if="stationInfo.generationPower ==null"></DashLine>
			<DashLine class="LDash mb05x" :dashLine="true" :viewWidth="DashWidth" :viewHeight="38" :isAnimation="false" :isArrow="false" v-else-if="stationInfo.generationPower==0"></DashLine>
			<DashLine class="LDash mb05x" :dashLine="true" :viewWidth="DashWidth" :viewHeight="38" v-else></DashLine>
			<DashLine class="LDash mb05x" :dashLine="true" :direction="'LT'" :isAnimation="true" :viewWidth="DashWidth" :viewHeight="38" v-if="stationInfo.wireStatus =='GRID_CONNECTED'"></DashLine>
			<DashLine class="LDash mb05x" :dashLine="true" :direction="'TL'" :isAnimation="true" :viewWidth="DashWidth" :viewHeight="38" v-if="stationInfo.wireStatus =='PURCHASE'"></DashLine>
			<DashLine class="LDash mb05x" :dashLine="true" :direction="'LT'" :isAnimation="false" :isColor="true" :viewWidth="DashWidth" :viewHeight="38" :isArrow="false" v-if="stationInfo.wireStatus =='STATIC'"></DashLine>
			<DashLine class="LDash mb05x" :dashLine="true" :direction="'LT'" :isAnimation="false" :isArrow="false" :isColor="false" :viewWidth="DashWidth" :viewHeight="38" v-if="stationInfo.wireStatus =='UNKNOWN'||stationInfo.wireStatus ==null"></DashLine>
		</div>
		<Icon name="ACDC" class="acdc w2x h2x dpB mc" />
		<div class="mt05x taC dpIB_E ml2x_E mr2x_E">
			<DashLine class="LDash" :dashLine="true" :viewWidth="DashWidth" :viewHeight="38" :direction="stationInfo.batteryStatus=='CHARGE'?'RB':'BR'" :isAnimation="['CHARGE','DISCHARGE'].indexOf(stationInfo.batteryStatus)>=0?true:false" :isArrow="['CHARGE','DISCHARGE'].indexOf(stationInfo.batteryStatus)>=0?true:false" :isColor="['CHARGE','DISCHARGE','STATIC'].indexOf(stationInfo.batteryStatus)>=0?true:false"></DashLine>
			<DashLine class="LDash" :dashLine="true" :viewWidth="DashWidth" :viewHeight="38" :direction="'LB'" :isAnimation="stationInfo.usePower?true:false" :isArrow="stationInfo.usePower?true:false" :isColor="(stationInfo.usePower!=null&&stationInfo.usePower>=0)?true:false"></DashLine>
		</div>
		<div class="clearfix pl05x pr05x mb05x">
			<div class="fL dpIB_E vaT_E">
				<div class="taC">
					<Icon :name="getBatteryIco(stationInfo.batterySoc)" class="w3x h2x dpB" :sizeBase="'xs'" />
					{{stationInfo.batterySoc!=null?floatFix(stationInfo.batterySoc,2)+"%":"--"}}
				</div>
				<div class="ml05x lh15">
					<span :title="getLanguageStr('word37','电池')">{{getLanguageStr('word37','电池')}}</span><br>
					<span v-if="stationInfo.batteryPower==null">--</span>
					<span v-else class="cMain" :title="convertData(Math.abs(stationInfo.batteryPower),2,'','kW')[0]"><span class="fs14x">{{convertData(Math.abs(stationInfo.batteryPower),2,"","kW")[1]}}</span> {{convertData(Math.abs(stationInfo.batteryPower),2,"","W")[2]}}</span>
				</div>
			</div>
			<div class="fR">
				<svg class="w3x h3x"><use xlink:href="#ico-house-useElectricity"></use></svg>
				<div class="dpIB lh15">
					<span :title="getLanguageStr('word561','用电')">{{getLanguageStr('word561','用电')}}</span><br>
					<span :title="convertData(stationInfo.usePower,2,'','W')[0]">
						<span v-if="stationInfo.usePower==null">--</span>
						<span v-else class="cMain"><span class="fs14x">{{convertData(Math.abs(stationInfo.usePower),2,"","W")[1]}}</span> {{convertData(stationInfo.usePower,2,"","W")[2]}}</span>
					</span>
				</div>
			</div>
		</div>
	</div>
</div>
</template>
<script>
import {getLanguageStr} from '@/util/language.js'
import * as equipmentApi from '@/api/maintain/plant/list'
import Loading from '@/components/common/ui/Loading'
import DashLine from '@/components/common/ui/DashLine'

import * as lib from '@/util/lib.js'
export default {
  // name:'stationSummary',
  components: {Loading, DashLine},
  updated () {
    this.handleWinWidth()
  },
  data () {
    return {
      isShow: false,
      isLoading: false,
      stationInfo: {},

      //        #电池状态            DISCHARGE  放电

      DashWidth: 0
    }
  },
  methods: {
    getLanguageStr,
    getTypeText: lib.getTypeText,
    floatFix: lib.floatFix,
    convertData: lib.convertData,
    show (data) {
      this.isShow = true
      if (data.stationInfo) {
        this.stationInfo = data.stationInfo
        setTimeout(() => {
          this.isLoading = false
        }, 500)
      } else {
        this._getList(data.stationId)
      }
      this.$set(this, 'DashWidth', parseInt(this.$refs.DashLines.clientWidth*.45-stage.space*4));
    },
    getBatteryIco: lib.getBatteryIco,
    handleWinWidth () {
      // window.onresize = () => {
      // 	return (() => {
      //         this.$set(this,"DashWidth",parseInt(this.$refs.DashLines.clientWidth*0.3))
      // 	})()
      // }
    },
    _getList (id) {
      this.isLoading = true
      equipmentApi.StationInfo(id).then(res => {
        trace(res, true)
        this.stationInfo = res
        if (!res) {
          this.stationInfo = {}
          this.stationInfo.powerNetworkState = null
        }
        this.isLoading = false
      }, error => {
        this.isLoading = false
				 !_.isEmpty(error) && this.$notify(error)
      })
    }
  },
  computed: {
  }
}
</script>
<style lang="scss" scoped>
.panel .title{ margin-bottom: 0 }
.acdc{margin:-1.2em auto;}
</style>



// WEBPACK FOOTER //
// src/view/maintain/light/plant/detail/FlowChart_storage.vue